import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild  } from '@angular/core';
import { NgForm } from '@angular/forms';

import { AuthHttpService } from '../../modules/auth/services/auth-http.service';
import { AuthService } from '../../modules/auth/services/auth.service';
import { Profile } from './interfaces/profile';
import { StudentDataService } from '../../services/student-data.service';
import { TelemetryService } from '../../services/telemetry.service';

import { environment } from 'environments/environment';

// Icons
import { faQuestionCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'shared-create-student-profile-form',
  templateUrl: './create-student-profile-form.component.html',
  styleUrls: ['./create-student-profile-form.component.scss'],
  providers: [StudentDataService],
  standalone: false
})
export class CreateStudentProfileFormComponent implements AfterViewInit, OnInit {

  @Input() customerId: number | null = null;
  @Output() profileCreatedEvent = new EventEmitter<boolean>();
  @ViewChild('profileForm') public form: NgForm;

  // Convert associated array of countries to array for easier processing in typeahead
  environment = environment;
  isInvalidSubmitted = false;
  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  profile: Profile = ({} as Profile);
  years = [];

  // Progress flags
  errorSaving = '';
  isSaving = false;

  // Icons
  faQuestionCircle = faQuestionCircle;
  faSpinner = faSpinner;

  constructor(
    private authHttpService: AuthHttpService,
    private authService: AuthService,
    private studentDataService: StudentDataService,
    private telemetryService: TelemetryService
  ) { }

  ngOnInit() {

    // Initiate the student's profile
    this.profile.IsActive = true;

    // Set up last 100 years array (start 4 years ago)
    const startYear = new Date().getFullYear() - 4;
    this.years = [...Array.from(Array(100).keys()).map(key => startYear - key)];
  }

  ngAfterViewInit() {

    // Add telemetry
    this.setTelemetry();
  }

  onAccountChange() {

    // When an error showed up due to existing account, clear the error if the account is changed
    this.errorSaving = null;
  }

  register() {

    // Immediately leave if we're already saving
    if (!this.form.valid || this.isSaving) {

      // Show required fields
      this.isInvalidSubmitted = !this.form.valid;
      return;
    }

    // Show spinner
    this.isSaving = true;

    // Reset the status
    this.errorSaving = '';

    // Prepare payload to save
    const payload = {
      CustomerId: this.customerId,
      Student: this.profile
    };

    // Set the birth date
    payload.Student.BirthDate = new Date(payload.Student.BirthYear, parseInt(payload.Student.BirthMonth, 10));

    // Create student profile
    this.studentDataService.save(payload)
      .subscribe(
        (value) => {

          // Process value
          this.onRegisterSuccess(value);

          // Hide spinner
          this.isSaving = false;
        },
        (error) => {

          // Set the error
          this.errorSaving = error.error;

          // Hide spinner
          this.isSaving = false;
        }
      );
  }

  skip() {

    // Emit output that account creation has been canceled
    this.profileCreatedEvent.emit(false);
  }

  private onRegisterSuccess(sessionInfo: any) {

    // Emit output that account has been successfully created
    this.profileCreatedEvent.emit(true);
  }

  private setTelemetry() {
    setTimeout(() => this.telemetryService.inject('CLICK', 'create-student-profile-form-skip', null, true));
    setTimeout(() => this.telemetryService.inject('CLICK', 'create-student-profile-form-submit', null, true));
  }
}
